/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Status_CompleteInputs */



/**
* | output |
* | --- |
* | "Proxy import completed." |
*
* @param {Iconik_Proxy_Status_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_status_complete = /** @type {((inputs?: Iconik_Proxy_Status_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Status_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du proxy terminee.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy-Import abgeschlossen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione proxy completata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт через прокси завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de proxy completada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理导入完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシのインポートが完了しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी आयात पूर्ण हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação do proxy concluída.")
	return /** @type {LocalizedString} */ ("Proxy import completed.")
});